import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { InvitePage } from "@/features/invite/InvitePage";
import { VisitorTours } from "@/tours/VisitorTours";

/** P03 Accept an invite. Public, outside the _app layout. `state` stays a plain string so the forced ?state=loading and
 *  ?state=error checks still reach the page instead of failing validation. */
const search = z.object({ state: z.string().optional() });

export const Route = createFileRoute("/invite/$token")({
  validateSearch: search,
  component: InviteRoute,
});

function InviteRoute() {
  const { state } = Route.useSearch();
  const { token } = Route.useParams();
  return (
    <VisitorTours>
      <InvitePage token={token} state={state} />
    </VisitorTours>
  );
}
